<template>
  <b-modal id="data-popup-modal" hide-footer centered :title="modalTitle">
    <!--cast-s4-o2-exo3 v-if="dataset_type === 'exo3'" ></cast-s4-o2-exo3-->
    <cast-s4o v-if="dataset_type === 'exo3'" ></cast-s4o>
    <cast-ctd v-if="dataset_type === 'ctd-o2-chlora'"></cast-ctd>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// import CastS4O2Exo3 from '@/components/viewers/CastS4O2Exo3.vue'
// import CastChart from '@/components/viewers/CastChart.vue'
import CastS4o from '@/components/viewers/CastS4o.vue'
import CastCtd from '@/components/viewers/CastCtd.vue'

export default {
  name: 'DataPopupModal',
  components: {
    CastCtd,
    CastS4o
    // CastChart
    // CastS4O2Exo3
  },
  data () {
    return {
      dataset_type: null
    }
  },
  created: function () {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if ((mutation.type === 'select_async_dataset')) {
        this.dataset_type = this.selectedAsyncDataset.type
        this.controlDataPopupModal()
      }
    })
  },
  beforeDestroy () {
    // Unsubscribe from mutation
    this.unsubscribe()
  },
  methods: {
    controlDataPopupModal: function () {
      const dataset = this.selectedAsyncDataset
      if (dataset == null) {
        this.$bvModal.hide('data-popup-modal')
      } else {
        this.$bvModal.show('data-popup-modal')
      }
    }
  },
  computed: {
    ...mapState(['selectedAsyncDataset']),
    modalTitle: function () {
      if (this.dataset_type === 'exo3' || this.dataset_type === 'exo2') {
        return 'CTD Cast'
      } else if (this.dataset_type === 'ctd-o2-chlora') {
        return 'CTD (Tiefensonde)'
      } else {
        return 'Profile'
      }
    }
  }
}
</script>

<style scoped>
</style>
